import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getCitySlice = createAsyncThunk(
  "city/getCity",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/city/getCity", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const searchCitySlice = createAsyncThunk(
  "city/searchCity",
  async ({ searchQuery, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/city/getCity",
        {
          searchQuery,
          status: ["Active"],
          limit: 10, 
          currentPage: 1,
        },
        {
          headers: {
            token,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data.result.list;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  loading: false,
  cities: [],
  searchCities: [],
};

const citySlice = createSlice({
  name: "city",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCitySlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCitySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.cities = action.payload.result.list;
      })
      .addCase(getCitySlice.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(searchCitySlice.fulfilled, (state, action) => {
        state.searchCities = action.payload;
      });
  },
});

export default citySlice.reducer;
